<template>
    <div>
        <b-tabs small class="mt-2">
            <!-- ── Tab Histórico de Estados ── -->
            <b-tab title="Histórico de estados">
                <b-overlay :show="cargandoEstados" rounded="sm" class="mt-2">
                    <b-table
                        :items="historialEstados"
                        :fields="camposEstados"
                        small striped responsive show-empty
                        empty-text="Sin cambios de estado registrados."
                    >
                        <template #cell(estado)="row">
                            <b-badge :style="estiloEstado(row.item.data.estado)">
                                {{ nombreEstado(row.item.data.estado) }}
                            </b-badge>
                        </template>
                        <template #cell(estado_anterior)="row">
                            <b-badge v-if="estadoAnterior(row.item)" :style="estiloEstado(estadoAnterior(row.item))">
                                {{ nombreEstado(estadoAnterior(row.item)) }}
                            </b-badge>
                            <span v-else class="text-muted">—</span>
                        </template>
                        <template #cell(observacion)="row">
                            <span class="small">{{ row.item.data.observaciones_retiro || row.item.data.observaciones || '—' }}</span>
                        </template>
                        <template #cell(motivo)="row">
                            <span class="small text-danger" v-if="row.item.data.motivo_no_retiro">{{ row.item.data.motivo_no_retiro }}</span>
                            <span v-else class="text-muted">—</span>
                        </template>
                    </b-table>
                    <b-pagination
                        v-if="totalEstados > porPaginaEstados"
                        v-model="paginaEstados"
                        :total-rows="totalEstados"
                        :per-page="porPaginaEstados"
                        size="sm"
                        align="center"
                        @change="cargarEstados"
                    />
                </b-overlay>
            </b-tab>

            <!-- ── Tab Historial de Modificaciones ── -->
            <b-tab title="Historial de modificaciones">
                <b-overlay :show="cargandoCambios" rounded="sm" class="mt-2">
                    <b-table
                        :items="historialCambios"
                        :fields="camposCambios"
                        small striped responsive show-empty
                        empty-text="Sin modificaciones registradas."
                    >
                        <template #cell(campos)="row">
                            <div>
                                <b-badge
                                    v-for="campo in (row.item.data.columnasMondificadas || [])"
                                    :key="campo"
                                    variant="light"
                                    class="mr-1 mb-1 border text-dark"
                                    style="font-size:0.75rem"
                                >
                                    {{ etiquetaCampo(campo) }}
                                </b-badge>
                            </div>
                        </template>
                        <template #cell(valores)="row">
                            <div class="small">
                                <div v-for="campo in camposMostrablesDelLog(row.item)" :key="campo.clave">
                                    <span class="text-muted">{{ campo.etiqueta }}:</span>
                                    <span class="ml-1 font-weight-bold">{{ campo.valorNuevo }}</span>
                                    <span v-if="campo.valorAnterior" class="text-muted ml-1">(antes: {{ campo.valorAnterior }})</span>
                                </div>
                            </div>
                        </template>
                    </b-table>
                    <b-pagination
                        v-if="totalCambios > porPaginaCambios"
                        v-model="paginaCambios"
                        :total-rows="totalCambios"
                        :per-page="porPaginaCambios"
                        size="sm"
                        align="center"
                        @change="cargarCambios"
                    />
                </b-overlay>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { RepositoryFactory } from "../repositories/RepositoryFactory";

const retiroRepo = RepositoryFactory.get("retiro");

const ESTADOS = {
    1:  { nombre: 'Pendiente asignación', style: { backgroundColor: '#f0ad4e', color: '#212529' } },
    3:  { nombre: 'Asignado a proveedor', style: { backgroundColor: '#0d6efd', color: '#ffffff' } },
    14: { nombre: 'En proceso de retiro', style: { backgroundColor: '#6f42c1', color: '#ffffff' } },
    13: { nombre: 'Retirado',             style: { backgroundColor: '#198754', color: '#ffffff' } },
    15: { nombre: 'No realizado',         style: { backgroundColor: '#dc3545', color: '#ffffff' } },
};

const ETIQUETAS_CAMPO = {
    estado:               'Estado',
    id_proveedor:         'Proveedor asignado',
    fecha_asignacion:     'Fecha asignación',
    fecha_proceso_retiro: 'Inicio proceso',
    fecha_retiro_efectivo:'Fecha retiro efectivo',
    fecha_retiro_fallido: 'Fecha retiro fallido',
    observaciones:        'Observaciones',
    observaciones_retiro: 'Observaciones del retiro',
    motivo_no_retiro:     'Motivo no retiro',
    nombre_completo:      'Paciente',
    documento:            'Documento',
    telefono_1:           'Teléfono',
    barrio:               'Barrio',
    municipio:            'Municipio',
    departamento:         'Departamento',
    elementos_retiro:     'Equipos a retirar',
};

const CAMPOS_IGNORAR_DETALLE = new Set([
    'idTenant', 'idModulo', 'idUsuario', 'idVersion', 'id',
    'tipo_retiro', 'createat', 'updateat', 'activo',
]);

export default {
    name: 'HistorialRetiro',
    props: {
        idRetiro: { type: Number, required: true },
    },
    data() {
        return {
            // Estados
            historialEstados:  [],
            totalEstados:      0,
            paginaEstados:     1,
            porPaginaEstados:  10,
            cargandoEstados:   false,
            // Cambios
            historialCambios:  [],
            totalCambios:      0,
            paginaCambios:     1,
            porPaginaCambios:  10,
            cargandoCambios:   false,

            camposEstados: [
                { key: 'data.createat',  label: 'Fecha',            formatter: (v) => this.formatFecha(v) },
                { key: 'estado_anterior',label: 'Estado anterior' },
                { key: 'estado',         label: 'Nuevo estado' },
                { key: 'observacion',    label: 'Observación' },
                { key: 'motivo',         label: 'Motivo' },
            ],
            camposCambios: [
                { key: 'data.createat', label: 'Fecha', formatter: (v) => this.formatFecha(v) },
                { key: 'campos',        label: 'Campos modificados' },
                { key: 'valores',       label: 'Cambios' },
            ],
        };
    },
    watch: {
        idRetiro(newId) {
            if (newId) { this.cargarEstados(); this.cargarCambios(); }
        },
    },
    mounted() {
        if (this.idRetiro) { this.cargarEstados(); this.cargarCambios(); }
    },
    methods: {
        async cargarEstados(pagina) {
            if (pagina) this.paginaEstados = pagina;
            this.cargandoEstados = true;
            try {
                const resp = await retiroRepo.consultarHistorial(this.idRetiro, {
                    soloEstados: true,
                    page: this.paginaEstados,
                    size: this.porPaginaEstados,
                });
                this.historialEstados = resp.rows;
                this.totalEstados     = resp.count;
            } catch (e) { this.historialEstados = []; }
            finally { this.cargandoEstados = false; }
        },

        async cargarCambios(pagina) {
            if (pagina) this.paginaCambios = pagina;
            this.cargandoCambios = true;
            try {
                const resp = await retiroRepo.consultarHistorial(this.idRetiro, {
                    soloEstados: false,
                    page: this.paginaCambios,
                    size: this.porPaginaCambios,
                });
                this.historialCambios = resp.rows;
                this.totalCambios     = resp.count;
            } catch (e) { this.historialCambios = []; }
            finally { this.cargandoCambios = false; }
        },

        estadoAnterior(item) {
            return item.data.datos_anteriores?.estado ?? null;
        },

        camposMostrablesDelLog(item) {
            const campos = item.data.columnasMondificadas || [];
            const actual   = item.data;
            const anterior = item.data.datos_anteriores || {};
            return campos
                .filter(c => !CAMPOS_IGNORAR_DETALLE.has(c))
                .map(c => {
                    let valorNuevo    = actual[c];
                    let valorAnterior = anterior[c];
                    // Formatear fechas
                    if (typeof valorNuevo === 'string' && valorNuevo.match(/^\d{4}-\d{2}-\d{2}T/)) {
                        valorNuevo    = this.formatFecha(valorNuevo);
                        valorAnterior = valorAnterior ? this.formatFecha(valorAnterior) : null;
                    }
                    // Formatear arrays (elementos_retiro)
                    if (Array.isArray(valorNuevo)) valorNuevo = `[${valorNuevo.join(', ')}]`;
                    if (Array.isArray(valorAnterior)) valorAnterior = `[${valorAnterior.join(', ')}]`;
                    return {
                        clave:         c,
                        etiqueta:      ETIQUETAS_CAMPO[c] || c,
                        valorNuevo:    valorNuevo ?? '—',
                        valorAnterior: (valorAnterior !== undefined && valorAnterior !== valorNuevo)
                                        ? valorAnterior : null,
                    };
                })
                .filter(c => c.valorNuevo !== '—');
        },

        etiquetaCampo(campo) { return ETIQUETAS_CAMPO[campo] || campo; },
        nombreEstado(e)  { return ESTADOS[e]?.nombre || `Estado ${e}`; },
        estiloEstado(e)  { return ESTADOS[e]?.style  || { backgroundColor: '#6c757d', color: '#fff' }; },
        formatFecha(f) {
            if (!f) return '—';
            return new Date(f).toLocaleDateString('es-CO', {
                day: '2-digit', month: '2-digit', year: 'numeric',
                hour: '2-digit', minute: '2-digit',
            });
        },
    },
};
</script>
